import { orpc } from "@/utils/orpc.client";

export function getCompanyChildCompaniesQueryOptions(companyId: string) {
  return orpc.music.getCompanyChildCompanies.queryOptions({ input: { id: companyId } });
}
